<template>
  <div class="car-content car-main-tab-content car-service-request car-reduced-width">
    <div class="car-content-introduction">
      <span class="car-headline">{{ $t('vehicleIdentification.title') }}</span>

      <p>{{ $t('vehicleIdentification.description') }}</p>
    </div>

    <div v-if="displayMethodSelectionTab" class="car-tabs car-reduced-width car-vehicle-identification">
      <router-link v-if="isLicensePlateIdentificationAllowed" class="car-tab car-tab-catalog" data-js="vehicleIdentification__tab--license-plate" :to="{ name: 'LicensePlateIdentification' }">
        {{ $t('licensePlateSelection.tabLabel') }}
      </router-link>

      <router-link v-if="isMethodAllowed(CATALOG)" class="car-tab car-tab-catalog" data-js="vehicleIdentification__tab--catalog" :to="{ name: 'CatalogIdentification' }">
        {{ $t('catalogSelection.tabLabel') }}
      </router-link>

      <router-link v-if="isMethodAllowed(HSN_TSN)" class="car-tab car-tab-hsn-tsn" data-js="vehicleIdentification__tab--hsn" :to="{ name: 'HsnTsnSelection' }">
        {{ $t('hsnTsnSelection.tabLabel') }}
      </router-link>

      <router-link v-if="isMethodAllowed(VIN)" class="car-tab car-tab-vin" data-js="vehicleIdentification__tab--vin" :to="{ name: 'VinSelection' }">
        {{ $t('vinSelection.tabLabel') }}
      </router-link>
    </div>

    <router-view />
  </div>
</template>

<script>
import smpConfigUtil from '@/util/smp_config_utils';
import { get } from 'lodash';

export default {
  name: 'VehicleIdentificationParent',
  data() {
    return {
      allowedMethods: [],
      CATALOG: smpConfigUtil.VEHICLE_SELECTION_CATALOG,
      HSN_TSN: smpConfigUtil.VEHICLE_SELECTION_HSN_TSN,
      VIN: smpConfigUtil.VEHICLE_SELECTION_VIN
    }
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => {
      const goToRoute = (name, query) => {
        if (vm.$route.name !== name) {
          vm.$router.push({ name, query });
        }
      };

      if (vm.$route.query.vin && !vm.$route.fullPath.includes('vin-selection')) {
        goToRoute('VinSelection', vm.$route.query);
      } else {
        if (vm.isLicensePlateIdentificationAllowed) {
          goToRoute('LicensePlateIdentification');
        } else if (vm.isMethodAllowed(vm.CATALOG)) {
          goToRoute('CatalogIdentification');
        } else if (vm.isMethodAllowed(vm.HSN_TSN)) {
          goToRoute('HsnTsnSelection');
        } else if (vm.isMethodAllowed(vm.VIN)) {
          goToRoute('VinSelection');
        } else {
          goToRoute('NoSelectionAllowed');
        }
      }
    });
  },
  created() {
    this.allowedMethods = smpConfigUtil.getVehicleSelectionMethods();
  },
  methods: {
    isMethodAllowed(method) {
      return smpConfigUtil.isVehicleSelectionMethodAllowed(method);
    }
  },
  computed: {
    displayMethodSelectionTab() {
      // hide tabs for selection of vehicle identification method if there is only one method available (or none)
      let countSelectionMethods = this.isLicensePlateIdentificationAllowed ? 1 : 0;
      countSelectionMethods = countSelectionMethods + get(this, '$SMP_CONFIG.applicationConfig.vehicleSelectionConfig.selectionMethods', []).length;

      return countSelectionMethods > 1;
    },
    isLicensePlateIdentificationAllowed() {
      return this.$SMP_CONFIG?.contextConfig?.extended?.featureConfig?.engageMandantId && this.$SMP_CONFIG.contextConfig.extended.featureConfig.engageMandantId !== '';
    }
  }
}
</script>
